import React, { FC, useEffect, useState } from 'react';

import { Box, Center, useDisclosure } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { ActionButton } from 'components/DataEntry';
import { ListIcon } from 'components/Icons';
import { useVulnerabilityContext } from 'containers/Visibility/Vulnerabilities/Components/hooks/context';
import { useVulnerabilityTableColumns } from 'containers/Visibility/Vulnerabilities/Components/hooks/useVulnerabilityTableColumns';
import { HostsDrawer } from 'containers/Visibility/Vulnerabilities/Components/VulnerabilityTable/HostsDrawer';
import { CVEsByPackage } from 'containers/Visibility/Vulnerabilities/Components/VulnerabilityTable/Package/CVEsByPackage';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';
import { VulnerabilityViewByTabs } from 'containers/Visibility/Vulnerabilities/types';

import { actions } from '../../../slice';

export const PackageVulnerabilities: FC = () => {
  const dispatch = useDispatch();
  const { vulnerabilities } = useSelector(selectVulnerabilities);
  const { packagesColumns, tableActionModals } = useVulnerabilityTableColumns();
  const hosts = useDisclosure();
  const cvesDisclosure = useDisclosure();
  const [currentRecord, setCurrentRecord] = useState<Record<string, any>>({});
  const { getPackageVulnerabilities } = useVulnerabilityContext();

  useEffect(() => {
    getPackageVulnerabilities();
  }, [getPackageVulnerabilities]);

  return (
    <>
      <Box h="full">
        <Table
          data={vulnerabilities.data}
          isError={vulnerabilities.isError}
          columns={[
            ...packagesColumns,
            {
              header: 'Actions',
              render: ({ row }) => (
                <Center>
                  <ActionButton
                    label={'Show CVEs'}
                    icon={<ListIcon />}
                    onClick={e => {
                      e.stopPropagation();
                      cvesDisclosure.onOpen();
                      setCurrentRecord(row);
                    }}
                  />
                </Center>
              ),
              styles: { width: '60px', cell: { maxWidth: '60px' } },
            },
          ]}
          isLoading={vulnerabilities.isLoading}
          cursor="pointer"
          styles={{ header: { position: 'relative', zIndex: 800 } }}
          onRowClick={r => {
            setCurrentRecord(r);
            hosts.onOpen();
          }}
          pagination={{
            pageInfo: vulnerabilities.page.info,
            onChange: info =>
              dispatch(actions.updateVulnerabilityPageInfo(info)),
            totalCount: vulnerabilities.page.totalCount,
          }}
        />
      </Box>
      {tableActionModals}
      {hosts.isOpen && (
        <HostsDrawer
          row={currentRecord}
          isOpen={hosts.isOpen}
          onClose={hosts.onClose}
          selectedTab={VulnerabilityViewByTabs.Package}
        />
      )}
      {cvesDisclosure.isOpen && (
        <CVEsByPackage
          row={currentRecord}
          isOpen={cvesDisclosure.isOpen}
          onClose={cvesDisclosure.onClose}
          selectedTab={VulnerabilityViewByTabs.Package}
        />
      )}
    </>
  );
};
